import { DataBean } from "../DataBean";

export class ExportPhysical extends DataBean {


    public async exportPhysicalTaking(idPhysicalTaking:any,state:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_exportPhysicalTaking_Number_Number_Number", [idPhysicalTaking,state,idEmployee]);
    }

    //aqui

 
}